import { render, staticRenderFns } from "./Brsk-page.vue?vue&type=template&id=0511148d&"
import script from "./Brsk-page.vue?vue&type=script&lang=js&"
export * from "./Brsk-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports